import moment from "moment-timezone";

// ✅ Corrected date difference logic using moment for calendar accuracy
const getRemainTime = (enddate) => {
  if (!enddate) return { totalDays: 0, message: "" };

  const today = moment().startOf('day');
  const end = moment(enddate).startOf('day');

  const diffDays = end.diff(today, 'days');
  const absDiffDays = Math.abs(diffDays);

  if (diffDays === 0) return { totalDays: 0, message: "Due today" };

  // Calculate years, months, days accurately
  const start = diffDays > 0 ? today.clone() : end.clone();
  const target = diffDays > 0 ? end.clone() : today.clone();

  const years = target.diff(start, 'years');
  start.add(years, 'years');

  const months = target.diff(start, 'months');
  start.add(months, 'months');

  const days = target.diff(start, 'days');

  let parts = [];
  if (years > 0) parts.push(`${years} year${years > 1 ? "s" : ""}`);
  if (months > 0) parts.push(`${months} month${months > 1 ? "s" : ""}`);
  if (days > 0) parts.push(`${days} day${days > 1 ? "s" : ""}`);

  let message = parts.join(" ");
  message += diffDays > 0 ? " left" : " delay";

  return { totalDays: diffDays, message };
};

export default function GetRemainDays({ enddate }) {
  const { totalDays, message } = getRemainTime(enddate);

  return (
    <>
      {enddate && (
        <span
          className="deadline-p d-flex align-items-center"
          style={{columnGap:'5px'}}
        >
          <i
            className="fa-regular fa-clock"
            aria-hidden="true"
            style={{ color: totalDays < 0 ? "red" : "green" }}
          ></i> 
          <p style={{ color: totalDays < 0 ? "red" : "green" }}>{message}</p>
        </span>
      )}
    </>
  );
}
